import { useEffect } from 'react';

import { useGlMap } from '../../contexts/context';

export interface MapLayerProps {
  source?: {
    id: string;
    data: mapboxgl.AnySourceData;
  };
  layers: mapboxgl.AnyLayer | mapboxgl.AnyLayer[];
}

const SourceLayers = ({ source, layers }: MapLayerProps) => {
  const glMap = useGlMap();

  useEffect(() => {
    if (!glMap) {
      return;
    }

    let sourceWasInitialized = false;
    const initializedLayerIds: string[] = [];

    const initializeLayer = () => {
      if (source && !glMap.getSource(source.id)) {
        glMap.addSource(source.id, source.data);

        sourceWasInitialized = true;
      }

      (Array.isArray(layers) ? layers : [layers]).forEach((layer) => {
        if (!glMap.getLayer(layer.id)) {
          glMap.addLayer(layer);

          initializedLayerIds.push(layer.id);
        }
      });
    };

    glMap.on('styledata', initializeLayer);
    (function tryInitializeSource() {
      if (glMap.loaded()) {
        initializeLayer();
      } else {
        setTimeout(tryInitializeSource, 50);
      }
    })();

    return () => {
      glMap.off('styledata', initializeLayer);

      if (initializedLayerIds.length) {
        initializedLayerIds.forEach((layerId) => {
          if (glMap.getLayer(layerId)) {
            glMap.removeLayer(layerId);
          }
        });
      }

      if (source && sourceWasInitialized && glMap.getSource(source.id)) {
        glMap.removeSource(source.id);
      }
    };
  }, [glMap, layers, source]);

  return null;
};

export default SourceLayers;
